import React, { useMemo } from 'react'
import { Form as FForm } from 'react-final-form'
import { Formik } from 'formik'
import { set, get } from 'lodash'
import Ajv from 'ajv'

import { getSchema } from '../../requests/getSchema'
import { useRequest } from '../../hooks/request'

const formValidator = new Ajv({ allErrors: true })

const defaultInitial = {}

const forwardedErrors = ['format', 'maxLength', 'pattern']

const ajvErrorsToFormErrors = ({ errors }) => {
  const formErrors = { }
  if (errors) {
    errors.forEach((error) => {
      const pathKey = error.schemaPath.substring(1)
      if (error.keyword === 'required') {
        set(formErrors, `${pathKey ? `${pathKey}.` : ''}${error.params.missingProperty}`, 'validation.required')
      } else if (error.keyword === 'minLength') {
        set(formErrors, pathKey, 'validation.required')
      } else if (error.keyword === 'additionalProperties') {
        // ignore, sometimes we need the form to have values that will not be forwarded to the request
      } else if (error.keyword === 'if') {
        // quite costly to read into the schema to know what error to raise, so the form will have to know itself
      } else if (error.keyword === 'enum') {
        set(formErrors, pathKey, 'validation.enum')
      } else if (forwardedErrors.includes(error.keyword)) {
        set(formErrors, pathKey, error.message)
      } else {
        throw new Error(`Unhandled error keyword: ${error.keyword}`)
      }
    })
  }

  return formErrors
}

export const Form = ({
  path, initialValues = defaultInitial, validate, formik, ...rest
}) => {
  const schemaRequest = useRequest({
    request: () => getSchema({ path }),
    start: path,
  })
  const localInitialValues = useMemo(() => ({ ...initialValues }), [initialValues])


  const schema = get(schemaRequest, 'state.data') // need to handle schema errors here
  const internValidate = (values) => {
    const propsErrors = validate ? validate(values) : {}
    if (!schema) {
      return propsErrors
    } // TODO handle errors

    const schemaValidator = formValidator.compile(schema)
    schemaValidator(values)

    return { ...propsErrors, ...ajvErrorsToFormErrors({ errors: schemaValidator.errors }) }
  }

  return (
    formik
      ? <Formik validate={internValidate} {...rest} initialValues={localInitialValues} />
      : <FForm validate={internValidate} {...rest} initialValues={localInitialValues} />
  )
}
